import { env } from '@/env';
import type { CmsApiOptions } from '../types/CmsApiOptions';
import { joinLinks } from './joinLinks';

export function sitePathPrefix(options?: CmsApiOptions & { absolute?: boolean }): string {
    return joinLinks(options?.absolute ? env.NEXT_PUBLIC_SITE_BASE_URL : undefined, options?.site?.urlSegment, options?.locale?.urlSegment);
}
